var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#2E73DC",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40366 2.85369L6.17349 3.08383C6.02095 3.23637 6.02095 3.4837 6.17349 3.63627L12.5372 10L6.17349 16.3637C6.02095 16.5163 6.02095 16.7636 6.17349 16.9162L6.40366 17.1463C6.5562 17.2989 6.80353 17.2989 6.95607 17.1463L13.8262 10.2762C13.9788 10.1237 13.9788 9.87634 13.8262 9.72377L6.95607 2.85369C6.80353 2.70111 6.5562 2.70111 6.40366 2.85369Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11470_9012",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 8,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40366 2.85369L6.17349 3.08383C6.02095 3.23637 6.02095 3.4837 6.17349 3.63627L12.5372 10L6.17349 16.3637C6.02095 16.5163 6.02095 16.7636 6.17349 16.9162L6.40366 17.1463C6.5562 17.2989 6.80353 17.2989 6.95607 17.1463L13.8262 10.2762C13.9788 10.1237 13.9788 9.87634 13.8262 9.72377L6.95607 2.85369C6.80353 2.70111 6.5562 2.70111 6.40366 2.85369Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11470_9012)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-right.3f3c315f40611b323e4805d5755fb951.svg";